import { Link } from "react-router";
import GridShape from "../common/GridShape";

export default function SignSidebar() {
  return (
    <div className="relative items-center justify-center flex-1 hidden p-8 z-1 bg-brand-950 dark:bg-white/5 lg:flex">
      {/* <!-- ===== Common Grid Shape Start ===== --> */}
      <GridShape />
      <div className="flex flex-col items-center max-w-xs">
        <Link to="/" className="block mb-4">
          <img src="./images/logo/tms-dark.svg" alt="Logo" />
        </Link>
        <p className="text-center text-gray-400 dark:text-white/60">
          We provide a simple transport management system.
        </p>
      </div>
    </div>
  );
}
